import { Accordion, AccordionBody, AccordionHeader, AccordionItem, Button, Card, CardBody, CardHeader, Col, FormGroup, Row, Table, Modal, ModalBody, ModalHeader, ModalFooter, InputGroup } from "reactstrap"
import { LabelText } from "../Utils/Input"
import { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import CommonDateTimePicker from "../Utils/CommonDateTimePicker"
import moment from "moment"
import InputField from "../Utils/InputField"
import formSchema from "../Utils/schema.json";
import { RenderField } from "../Utils/renderFields";
import { handleRadioButtonChange } from "./constants/SimulateFunctions"
import SelectField from "../Utils/SelectField"
import LimitOverride from "./LimitOverride"
import OfferCard from "../OrderManagement/OfferCard"
import {
    Carousel,
    CarouselItem,
    CarouselControl,
    CarouselIndicators,
    CarouselCaption,
} from 'reactstrap';

export const OfferFilterAccordion = ({ setSelectedOfferName, setOfferAttributes, immediate, immediateMinus, nextBillCycle, setImmediate, setImmediateMinus, setNextBillCycle, offerCode, open, toggle, loading, filteredResults, navigate, startsOn, setEndsOn, setStartsOn, endsOn, setSelectedOfferCode, customerIdPath, setQuantity, quantity, setPostExpiry, postExpiry, overrideResource, setOverrideResource, isChangeOffer, values, touched, errors, setFieldValue, handleBlur, createCustomerActionType, nonCreateCustomerActionType }) => {
    const [selectedItemIndex, setSelectedItemIndex] = useState(null);
    const [selectedServiceIndex, setSelectedServiceIndex] = useState(null)
    const [attributes, setAttributes] = useState(false);
    const [viewDetails, setViewDetails] = useState({})

    const [openViewMoreModalKey, setOpenViewMoreModalKey] = useState(null);

    const [openSubscriptionModalKey, setOpenSubscriptionModalKey] =
        useState(null);

    const dateFormat = localStorage.getItem("dateFormat") || "DD MMM YYYY";

    const openViewMoreModal = (index, offerIndex) => {
        setOpenViewMoreModalKey(`${index}-${offerIndex}`);
    };

    const closeViewMoreModal = () => {
        setOpenViewMoreModalKey(null);
    };

    const openSubscriptionModal = (index, offerIndex) => {
        setOpenSubscriptionModalKey(`${index}-${offerIndex}`);
    };

    const closeSubscriptionModal = () => {
        setOpenSubscriptionModalKey(null);
    };
    const handleSelect = (offer, offerIndex, index) => {
        {
            setSelectedItemIndex(
                offerIndex
            );
            setSelectedServiceIndex(index);
            setAttributes(
                offer.provisioningAttributes
                    .length > 0
            );
            const grants =
                offer?.Grants?.filter(
                    (grant) =>
                        grant.overridable === true
                )?.map(
                    (grant) =>
                        grant.resourceName
                );
            const charges =
                offer?.Charges?.filter(
                    (charge) =>
                        charge.overridable ===
                        true
                )?.map(
                    (charge) =>
                        charge.resourceName
                );
            setResourceOptions([
                ...grants,
                ...charges,
            ]);
            {
                !isChangeOffer &&
                    setOverrideResource(
                        (prev) => ({
                            ...prev,
                            [offerIndex]: prev[
                                offerIndex
                            ] || [
                                    {
                                        resourceName: null,
                                        value: "",
                                    },
                                ],
                        })
                    );
            }
            if (
                customerIdPath ===
                "create-customer"
            ) {
                setStartsOn(null);
                setEndsOn(null);
                setSelectedOfferCode(
                    offer.offerCode
                );
                setQuantity(1);
            } else {
                setImmediate(true);
                setImmediateMinus(false);
                setNextBillCycle(false);
                setPostExpiry(false);
                setOfferAttributes(
                    offer?.provisioningAttributes
                );
                setSelectedOfferCode(
                    offer?.offerCode
                );
                setSelectedOfferName(
                    offer?.offerName
                );
            }
        }
    }
    const [resourceOptions, setResourceOptions] = useState([])
    const handleAddResource = (offerIndex) => {
        setOverrideResource(prev => ({
            ...prev,
            [offerIndex]: [
                ...(prev[offerIndex] || []),
                { resourceName: null, value: '' }
            ]
        }));
    };
    const handleRemoveResource = (offerIndex, resourceIndex) => {
        setOverrideResource(prev => {
            const updatedResources = [...(prev[offerIndex] || [])];
            updatedResources.splice(resourceIndex, 1);

            return {
                ...prev,
                [offerIndex]: updatedResources
            };
        });
    };
    const toggleViewDetails = (serviceIndex, offerIndex) => {
        const key = `${serviceIndex}-${offerIndex}`;
        setViewDetails((prevState) => ({
            ...prevState,
            [key]: !prevState[key],
        }));
    };

    const handleSubmit = customerIdPath === "create-customer"
        ? createCustomerActionType
        : nonCreateCustomerActionType;

    const [activeIndices, setActiveIndices] = useState({});


    const next = (key, chunkCount) => {
        setActiveIndices((prev) => ({
            ...prev,
            [key]: ((prev[key] ?? 0) + 1) % chunkCount,
        }));
    };

    const previous = (key, chunkCount) => {
        setActiveIndices((prev) => ({
            ...prev,
            [key]: ((prev[key] ?? 0) - 1 + chunkCount) % chunkCount,
        }));
    };

    const goToIndex = (key, index) => {
        setActiveIndices((prev) => ({
            ...prev,
            [key]: index,
        }));
    };

    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [isMediumToLargeScreen, setIsMediumToLargeScreen] = useState(window.innerWidth >= 768 && window.innerWidth < 1400);
    const [animating, setAnimating] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
            setIsMediumToLargeScreen(window.innerWidth >= 768 && window.innerWidth < 1400)
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const offerSlides = (offers, serviceIndex) => {
        const numberOfItems = isMobile ? 1 : isMediumToLargeScreen ? 3 : 4;
        const offerChunks = [];
        for (let i = 0; i < offers.length; i += numberOfItems) {
            offerChunks.push(offers.slice(i, i + numberOfItems));
        }

        const slides = offerChunks.map((offerChunk, index) => (
            <CarouselItem
                key={`chunk-${index}`}
                onExiting={() => setAnimating(true)}
                onExited={() => setAnimating(false)}
            >
                <div className="d-flex justify-content-center w-100">
                    <Row className="px-2 w-95">
                        {offerChunk.map((offer, offerIndex) => {
                            const adjustedOfferIndex = index * numberOfItems + offerIndex
                            return (
                                <Col
                                    key={adjustedOfferIndex}
                                    lg={4}
                                    xxl={3}
                                    sm={12}
                                    className="mb-4"
                                >
                                    <OfferCard
                                        offer={offer}
                                        index={serviceIndex}
                                        offerIndex={adjustedOfferIndex}
                                        openViewMoreModal={openViewMoreModal}
                                        openSubscriptionModal={openSubscriptionModal}
                                        closeSubscriptionModal={closeSubscriptionModal}
                                        handleSelect={handleSelect}
                                        offerCode={offerCode}
                                    />
                                    <Modal
                                        isOpen={openSubscriptionModalKey === `${serviceIndex}-${adjustedOfferIndex}`}
                                        fade={false}
                                        toggle={closeSubscriptionModal}
                                        className={
                                            customerIdPath === "create-customer"
                                                ? "custom-modal-width-850 offerModal"
                                                : "offerModal"
                                        }
                                        centered={true}
                                    >
                                        <ModalHeader

                                            className="d-flex justify-content-center rv-breadcrumb-border p-3"
                                        >
                                            <div className="w-100 text-center">
                                                {customerIdPath === "create-customer"
                                                    ? "Subscription"
                                                    : "Schedule"}
                                            </div>
                                            <button type="button" className="close-button-currency mt-n1 fs-1 align-self-center" onClick={closeSubscriptionModal}>
                                                &times;
                                            </button>
                                        </ModalHeader>
                                        <ModalBody>
                                            {selectedItemIndex === adjustedOfferIndex &&
                                                selectedServiceIndex === serviceIndex && (
                                                    <>
                                                        {customerIdPath === "create-customer" ? (
                                                            <>
                                                                <Row className="gy-3 mt-1">
                                                                    <Col lg={4} md={12}>
                                                                        <div>
                                                                            <FormGroup>
                                                                                <LabelText
                                                                                    htmlFor={"startsOn"}
                                                                                    classLabelName={"ms-0 rv-form-label"}
                                                                                    className={"text-danger"}
                                                                                    displayText={"Subscription Starts On"}
                                                                                />
                                                                                <LabelText
                                                                                    htmlFor={"startsOn"}
                                                                                    classLabelName={`d-block ms-0 rv-sub-label rv-label-muted`}
                                                                                    displayText={dateFormat}
                                                                                />
                                                                                <CommonDateTimePicker
                                                                                    placeholder=""
                                                                                    className={`form-control`}
                                                                                    value={startsOn}
                                                                                    name={`startsOn`}
                                                                                    handleChange={(values) => {
                                                                                        setStartsOn(values);
                                                                                    }}
                                                                                    format={dateFormat}
                                                                                    views={["year", "month", "day"]}
                                                                                />
                                                                            </FormGroup>
                                                                        </div>
                                                                    </Col>
                                                                    <Col lg={4} md={12}>
                                                                        <div>
                                                                            <FormGroup>
                                                                                <LabelText
                                                                                    htmlFor={"endsOn"}
                                                                                    classLabelName={"ms-0 rv-form-label"}
                                                                                    className={"text-danger"}
                                                                                    displayText={"Subscription Ends On"}
                                                                                />
                                                                                <LabelText
                                                                                    htmlFor={"endsOn"}
                                                                                    classLabelName={`d-block ms-0 rv-sub-label rv-label-muted`}
                                                                                    displayText={dateFormat}
                                                                                />
                                                                                <CommonDateTimePicker
                                                                                    className={`form-control`}
                                                                                    value={endsOn}
                                                                                    name={`endsOn`}
                                                                                    minDate={startsOn}
                                                                                    handleChange={(values) => {
                                                                                        setEndsOn(values);
                                                                                    }}
                                                                                    format={dateFormat}
                                                                                    views={["year", "month", "day"]}
                                                                                />
                                                                            </FormGroup>
                                                                        </div>
                                                                    </Col>
                                                                    <Col lg={4} md={12}>
                                                                        <FormGroup>
                                                                            <LabelText
                                                                                htmlFor={"Quantity"}
                                                                                classLabelName={"ms-0 rv-form-label"}
                                                                                className={"text-danger"}
                                                                                displayText={"Quantity"}
                                                                            />
                                                                            <LabelText
                                                                                htmlFor={"Quantity"}
                                                                                classLabelName={`d-block ms-0 rv-sub-label rv-label-muted`}
                                                                                displayText={"Select Quantity"}
                                                                            />
                                                                            <InputGroup className="border border-1 rounded-1 d-flex justify-content-between align-items-center">
                                                                                <input
                                                                                    type="number"
                                                                                    className="quantity-input mx-2 border-0 rv-label-muted "
                                                                                    id="quantity"
                                                                                    value={quantity}
                                                                                    onChange={(e) => {
                                                                                        const value = e.target.value;
                                                                                        if (value === "") {
                                                                                            setQuantity("");
                                                                                        } else {
                                                                                            setQuantity(
                                                                                                Math.max(1, Number(value))
                                                                                            );
                                                                                        }
                                                                                    }}
                                                                                    min={1}
                                                                                />
                                                                                <div className="text-end flex-grow-1">
                                                                                    <button
                                                                                        className="border-0 bg-transparent"
                                                                                        type="button"
                                                                                        onClick={() =>
                                                                                            setQuantity((prev) =>
                                                                                                Math.max(1, prev - 1)
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        <span className="rv-label-muted fw-bold">
                                                                                            -
                                                                                        </span>
                                                                                    </button>
                                                                                    <span className="rv-label-muted ">
                                                                                        |
                                                                                    </span>
                                                                                    <button
                                                                                        className="border-0 bg-transparent fw-bold"
                                                                                        type="button"
                                                                                        onClick={() =>
                                                                                            setQuantity((prev) => prev + 1)
                                                                                        }
                                                                                    >
                                                                                        <span className="rv-label-muted ">
                                                                                            +
                                                                                        </span>
                                                                                    </button>
                                                                                </div>
                                                                            </InputGroup>
                                                                        </FormGroup>
                                                                    </Col>{" "}
                                                                </Row>
                                                                <div className="text-center text-black fw-bold fs-18 my-1">
                                                                    Resource Override
                                                                </div>
                                                                <Row className="gy-3 mt-1">
                                                                    {(Array.isArray(overrideResource[adjustedOfferIndex])
                                                                        ? overrideResource[adjustedOfferIndex]
                                                                        : []
                                                                    ).map((resource, resourceIndex) => (
                                                                        <div
                                                                            key={resourceIndex}
                                                                            className="d-flex flex-wrap mb-1 flex-column flex-md-row"
                                                                        >
                                                                            <Col lg={4} sm={12} className="pe-2">
                                                                                <FormGroup>
                                                                                    <LabelText
                                                                                        htmlFor={"resourceName"}
                                                                                        classLabelName={"ms-0 rv-form-label"}
                                                                                        className={"text-danger"}
                                                                                        displayText={"Resource Name"}
                                                                                    />
                                                                                    <LabelText
                                                                                        htmlFor={"resourceName"}
                                                                                        classLabelName={`d-block ms-0 rv-sub-label rv-label-muted `}
                                                                                        displayText={"Enter Resource Name"}
                                                                                    />

                                                                                    <SelectField
                                                                                        name={`resourceName-${resourceIndex}`}
                                                                                        options={resourceOptions
                                                                                            .filter(
                                                                                                (option) =>
                                                                                                    !overrideResource[
                                                                                                        adjustedOfferIndex
                                                                                                    ]?.some(
                                                                                                        (r) =>
                                                                                                            r.resourceName?.value ===
                                                                                                            option
                                                                                                    )
                                                                                            )
                                                                                            .map((option) => ({
                                                                                                value: option,
                                                                                                label: option,
                                                                                            }))}
                                                                                        value={resource.resourceName}
                                                                                        handleChange={(selectedOption) => {
                                                                                            setOverrideResource((prev) => ({
                                                                                                ...prev,
                                                                                                [adjustedOfferIndex]: prev[
                                                                                                    adjustedOfferIndex
                                                                                                ].map((r, i) =>
                                                                                                    i === resourceIndex
                                                                                                        ? {
                                                                                                            ...r,
                                                                                                            resourceName:
                                                                                                                selectedOption,
                                                                                                        }
                                                                                                        : r
                                                                                                ),
                                                                                            }));
                                                                                        }}
                                                                                        placeholder=""
                                                                                        isRVStyle={true}
                                                                                        isClearable={true}
                                                                                    />
                                                                                </FormGroup>
                                                                            </Col>
                                                                            <Col lg={4} sm={12} className="pe-2">
                                                                                <FormGroup>
                                                                                    <LabelText
                                                                                        htmlFor={"Value"}
                                                                                        classLabelName={"ms-0 rv-form-label"}
                                                                                        className={"text-danger"}
                                                                                        displayText={"Value"}
                                                                                    />
                                                                                    <LabelText
                                                                                        htmlFor={"resourceName"}
                                                                                        classLabelName={`d-block ms-0 rv-sub-label rv-label-muted `}
                                                                                        displayText={"Enter Value"}
                                                                                    />
                                                                                    <InputField
                                                                                        name={`value-${resourceIndex}`}
                                                                                        placeholder={""}
                                                                                        type={"text"}
                                                                                        className={"form-control"}
                                                                                        id={`value-${resourceIndex}`}
                                                                                        value={resource.value}
                                                                                        handleChange={(e) => {
                                                                                            const newValue = e.target.value;
                                                                                            setOverrideResource((prev) => ({
                                                                                                ...prev,
                                                                                                [adjustedOfferIndex]: prev[
                                                                                                    adjustedOfferIndex
                                                                                                ].map((r, i) =>
                                                                                                    i === resourceIndex
                                                                                                        ? {
                                                                                                            ...r,
                                                                                                            value: newValue,
                                                                                                        }
                                                                                                        : r
                                                                                                ),
                                                                                            }));
                                                                                        }}
                                                                                    />
                                                                                </FormGroup>
                                                                            </Col>
                                                                        </div>
                                                                    ))}
                                                                </Row>
                                                                <div className="text-center text-black fw-bold fs-18 my-1">
                                                                    Ceiling/Floor
                                                                </div>
                                                                <div className="gy-3 mt-1">
                                                                    <LimitOverride
                                                                        values={values}
                                                                        touched={touched}
                                                                        errors={errors}
                                                                        setFieldValue={setFieldValue}
                                                                        isFromSubscriptionModal={true}
                                                                    />
                                                                </div>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <Row className="gy-3 my-2 pb-3">
                                                                    {formSchema.map(
                                                                        (section, sectionIndex) =>
                                                                            section.title === "Change Offer" &&
                                                                            section.sections.map(
                                                                                (subSection, subSectionIndex) =>
                                                                                    subSection.fields &&
                                                                                    subSection.fields.map(
                                                                                        (field, fieldIndex) => (
                                                                                            <RenderField
                                                                                                setRadioValue={() =>
                                                                                                    handleRadioButtonChange(
                                                                                                        field.label,
                                                                                                        setImmediate,
                                                                                                        setImmediateMinus,
                                                                                                        setNextBillCycle,
                                                                                                        setPostExpiry
                                                                                                    )
                                                                                                }
                                                                                                radioValue={
                                                                                                    field.label === "Immediate"
                                                                                                        ? immediate
                                                                                                        : field.label ===
                                                                                                            "Immediate Minus Used"
                                                                                                            ? immediateMinus
                                                                                                            : field.label ===
                                                                                                                "Next Bill Cycle"
                                                                                                                ? nextBillCycle
                                                                                                                : postExpiry
                                                                                                }
                                                                                                field={field}
                                                                                            />
                                                                                        )
                                                                                    )
                                                                            )
                                                                    )}
                                                                </Row>
                                                            </>
                                                        )}
                                                        {attributes && (
                                                            <div>
                                                                <div className="text-center text-black fw-bold fs-18 my-1">
                                                                    Attributes
                                                                </div>
                                                                <div className="border border-1 rounded-1 mt-1 overflow-y-auto-200">
                                                                    <Table className="table">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Name</th>
                                                                                <th>Value</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {offer?.provisioningAttributes.map(
                                                                                (attribute, index) => (
                                                                                    <tr
                                                                                        key={index}
                                                                                        className="border border-0"
                                                                                    >
                                                                                        <td className="border border-0">
                                                                                            {attribute.name}
                                                                                        </td>
                                                                                        <td className="border border-0">
                                                                                            {attribute.value}
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            )}
                                                                        </tbody>
                                                                    </Table>
                                                                </div>
                                                            </div>
                                                        )}

                                                        <div className="d-flex justify-content-center gap-2  m-auto mt-2">
                                                            <div className="d-flex gap-2">
                                                                <button
                                                                    type="button"
                                                                    className="btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap btn btn-secondary"
                                                                    onClick={closeSubscriptionModal}
                                                                >
                                                                    <i className="ri-close-line label-icon secondary-label-icon align-middle fs-16 me-2"></i>
                                                                    <span className="px-2 ms-2 me-1 fw-bold">
                                                                        Cancel
                                                                    </span>
                                                                </button>

                                                                <button
                                                                    type="submit"
                                                                    onClick={()=>{
                                                                        handleSubmit()
                                                                        closeSubscriptionModal()
                                                                    }}
                                                                    className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap btn btn-secondary"
                                                                >
                                                                    <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i>
                                                                    <span className="px-2 ms-2 me-1 fw-bold">
                                                                        Submit
                                                                    </span>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                        </ModalBody>
                                    </Modal>
                                    <Modal
                                        isOpen={openViewMoreModalKey === `${serviceIndex}-${adjustedOfferIndex}`}
                                        fade={false}
                                        toggle={closeViewMoreModal}
                                        centered={true}
                                    >
                                        <ModalHeader toggle={closeViewMoreModal}>
                                            {offer?.offerName}
                                        </ModalHeader>
                                        <ModalBody>
                                            <OfferCard
                                                offer={offer}
                                                index={serviceIndex}
                                                offerIndex={adjustedOfferIndex}
                                                openViewMoreModal={openViewMoreModal}
                                                closeViewMoreModal={closeViewMoreModal}
                                                isModal={true}
                                                handleSelect={handleSelect}
                                            />
                                            <div className="py-3 text-center">
                                                {offer.offerCode != offerCode ? (
                                                    <Button
                                                        className="w-100 rv-subscription-btn fs-16 fw-bold"
                                                        onClick={() => {
                                                            closeViewMoreModal();
                                                            handleSelect(offer, adjustedOfferIndex, serviceIndex);
                                                            openSubscriptionModal(serviceIndex, adjustedOfferIndex);
                                                        }}
                                                    >
                                                        Select
                                                    </Button>
                                                ) : (
                                                   <p className="fs-16 fw-bold rv-subscription-currentPlan-Label rounded-1 text-center">
                                                            Current Plan
                                                        </p>
                                                )}
                                            </div>
                                        </ModalBody>
                                    </Modal>
                                </Col>
                            );
                        })}
                    </Row>
                </div>
            </CarouselItem>
        ));

        return { slides, chunkCount: offerChunks.length };
    };

    const reOrderServices = (services) => {
        if (!Array.isArray(services)) return [];

        const serviceIndex = services.findIndex(
            ([_, offers]) =>
                Array.isArray(offers) &&
                offers.some(offer => offer.offerCode==offerCode)
        );

        if (serviceIndex === -1) return services;

        const clonedServices = [...services];

        const [serviceName, offers] = clonedServices[serviceIndex];

        const offersClone = [...offers];
        const currentPlanIndex = offersClone.findIndex(offer => offer.offerCode==offerCode);
        if (currentPlanIndex !== -1) {
            const [currentPlanOffer] = offersClone.splice(currentPlanIndex, 1);
            offersClone.unshift(currentPlanOffer);
        }
        const currentPlanService = [serviceName, offersClone];

        clonedServices.splice(serviceIndex, 1);
        clonedServices.unshift(currentPlanService);
        return clonedServices
    };

    return (
        <div className="offers">
            <div>
                {loading ? <p></p> : <div>
                    {reOrderServices(filteredResults)?.map(([serviceName, offers], index) => {
                        const { slides, chunkCount } = offerSlides(offers, index);
                        const indicators = [];
                        for (let i = 0; i < chunkCount; i++) {
                            indicators.push({ key: 'ind-' + i });
                        }
                        const currentIndex = activeIndices[serviceName] || 0;
                        return (
                            <div key={index} className="py-3">
                                <div className="d-flex justify-content-center w-100">
                                    <Row className="px-2 w-95">
                                        <Col
                                            md={4}
                                            xxl={3}
                                            sm={12}>
                                            <h2 className="fs-5 text-black fw-bold mb-0">{serviceName}</h2>
                                        </Col>
                                    </Row>

                                </div>

                                <Carousel
                                    activeIndex={currentIndex}
                                    next={() => next(serviceName, chunkCount)}
                                    previous={() => previous(serviceName, chunkCount)}
                                    className="my-3"
                                    interval={false}
                                >
                                    <CarouselIndicators
                                        items={indicators}
                                        activeIndex={currentIndex}
                                        onClickHandler={(newIdx) => goToIndex(serviceName, newIdx)}
                                    />

                                    {slides}

                                    <CarouselControl
                                        direction="prev"
                                        directionText="Previous"
                                        onClickHandler={() => previous(serviceName, chunkCount)}
                                        className={currentIndex === 0 ? "d-none" : ""}
                                    />
                                    <CarouselControl
                                        direction="next"
                                        directionText="Next"
                                        onClickHandler={() => next(serviceName, chunkCount)}
                                        className={currentIndex == chunkCount - 1 ? "d-none" : ""}
                                    />
                                </Carousel>
                            </div>
                        );
                    })}
                </div>}
            </div>
        </div>
    );
}
